import { RefObject, useEffect, useState } from 'react';

/** True while `ref`'s element is narrower than its content; drives `tabIndex` on scroll regions. */
export function useHorizontalOverflow(ref: RefObject<HTMLElement | null>, enabled = true) {
    const [overflowing, setOverflowing] = useState(false);

    useEffect(() => {
        const element = ref.current;
        if (!enabled || !element) return;
        const update = () => setOverflowing(element.scrollWidth > element.clientWidth);
        update();
        const observer = new ResizeObserver(update);
        observer.observe(element);
        if (element.firstElementChild) observer.observe(element.firstElementChild);
        return () => observer.disconnect();
    }, [ref, enabled]);

    return overflowing;
}
